import React, {lazy, Suspense} from 'react'
import t from 'format-message'

import {useParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Show = lazy(() => import('./components/pages/Show').then(({Show}) => ({default: Show})))
const Take = lazy(() => import('./components/pages/Take').then(({Take}) => ({default: Take})))
const Results = lazy(() =>
  import('./components/pages/Results').then(({Results}) => ({default: Results})),
)

export function ShowPage() {
  const {activeParticipantSessionId} = useParams()

  useDocumentTitle(t('Take'))

  return (
    <Suspense>
      <Show activeParticipantSessionId={activeParticipantSessionId} app="taking" />
    </Suspense>
  )
}

export function TakePage() {
  const {activeParticipantSessionId} = useParams()

  useDocumentTitle(t('Take'))

  return (
    <Suspense>
      <Take activeParticipantSessionId={activeParticipantSessionId} app="taking" />
    </Suspense>
  )
}

export function ResultsPage() {
  const {activeParticipantSessionId} = useParams()

  useDocumentTitle(t('Results'))

  return (
    <Suspense>
      <Results participantSessionId={activeParticipantSessionId} app="taking" />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the taking module.
 */
export const takingRoutes = [
  {
    index: true,
    element: <ShowPage />,
  },
  {
    path: 'take',
    element: <TakePage />,
  },
  {
    path: 'results',
    element: <ResultsPage />,
  },
]
